import React, { useEffect } from 'react';
import * as S from './styles';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { useDispatch, useSelector } from 'react-redux';
import InventorySearchServices from 'modules/store-inventory/services/InventorySearchServices';
import { convertObjectSopToString, defaultSop } from 'helpers/sop';
import { STOCK_KIND_TRANSLATE_ID } from 'modules/store-inventory/helpers/TranslateAggregations';
import useSnackBar from 'hooks/useSnackBar';
import { Skeleton } from '@material-ui/lab';

const SimilarVehicles = ({ onClick, currentVehicle }) => {
  const { currentDealer, currentProposal } = useSelector(state => ({
    ...state.dealerStore,
    ...state.proposalStore,
  }));

  const { handleSnackBarError } = useSnackBar();

  const [similarVehicleVin, setSimilarVehicleVin] = React.useState(null);

  const [isLoading, setIsLoading] = React.useState(false);

  const dispatch = useDispatch();

  const currentFeaturesFilterId = currentVehicle?.features?.map(
    feature => feature?.id
  );

  const getDealsStock = async () => {
    try {
      setIsLoading(true);

      const currentStockKindFilter = Object.values(
        STOCK_KIND_TRANSLATE_ID
      ).find(el => el.value === currentDealer.stockType);

      const currentVehicleAccessories = currentVehicle?.accessories;

      const vehicleDisplayName = currentVehicle?.externalVehicleName
        ? `${currentVehicle?.externalVehicleName}.1`
        : `${currentVehicle.makeName} ${
            currentVehicle.modelName
          } ${currentVehicle?.externalVehicle || currentVehicle.trimName}.1`;

      const sop = {
        ...defaultSop,
        avl_: 't.1',
        ops_: vehicleDisplayName,
        exc_: `${currentVehicle?.exteriorColor}.1`,
      };

      if (currentStockKindFilter?.id) {
        sop.skd_ = `${currentStockKindFilter?.id}${
          currentStockKindFilter?.value === STOCK_KIND_TRANSLATE_ID[1].value
            ? '|2'
            : ''
        }.1`;
      }

      const {
        success,
        data,
      }: any = await InventorySearchServices.searchExactVehicle({
        dealerId: currentProposal?.dealerId,
        page: 0,
        order: 15,
        sop: convertObjectSopToString(sop),
        accessories: currentVehicleAccessories,
      });
      if (success) {
        return data;
      }

      dispatch(
        handleSnackBarError('Não foi possível encontar veículo similar')
      );
    } catch {
      dispatch(
        handleSnackBarError('Não foi possível encontar veículo similar')
      );
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!currentVehicle) return;

    getDealsStock().then(data => {
      const firstResult = data?.results?.[0];

      if (data?.results?.length > 0) {
        if (firstResult?.vin !== currentVehicle?.vin) {
          setSimilarVehicleVin(firstResult?.vin);
          return;
        }
      }
      setSimilarVehicleVin('');
    });
  }, [currentVehicle]);

  if (!similarVehicleVin) {
    return null;
  }

  return (
    <S.SimilarVehiclesContainer>
      {isLoading && (
        <>
          <Skeleton variant="text" width="60%" />
          <Skeleton variant="text" width="90%" />
          <Skeleton variant="text" width="95%" />
          <Skeleton variant="text" width="80%" />
          <Skeleton variant="text" width={220} height={40} />
        </>
      )}
      {isLoading || (
        <>
          <S.AlertTitle>
            <WarningRoundedIcon />
            Veículo similar disponível!
          </S.AlertTitle>
          <S.AlertDescription>
            Existe um veículo com as mesmas características disponível em nosso
            estoque há mais dias. Recomendamos que você realize a troca deste
            veículo no pedido de venda para otimizar o giro do estoque.
            <strong>Nº Chassi: {similarVehicleVin}</strong>
          </S.AlertDescription>

          <S.AlertActionButton>
            <S.ButtonAlert onClick={() => onClick(similarVehicleVin)}>
              Clique aqui para trocar veículo
            </S.ButtonAlert>
          </S.AlertActionButton>
        </>
      )}
    </S.SimilarVehiclesContainer>
  );
};

export default SimilarVehicles;
